import React from "react";
import {
  Create,
  SimpleForm,
  TextInput,
  ImageField,
  Toolbar,
  ListButton,
  SaveButton,
  ImageInput,
} from "react-admin";
import { onAddonandVideoTaskLabelCreate } from "../../Service/Validation/AddonandVideoTaskLabelValidation";
import Grid from "@material-ui/core/Grid";
import { RichTextInput } from 'ra-input-rich-text';
import { LabelTypeSelectInput, LabelIdSelectInput, LabelTaskSelectInput } from "../../UI/Input/SelectInput";
const PageTitle = () => {
  return <span>Create Labels</span>;
};

const FormToolbar = (props) => (
  <Toolbar {...props}>
    <SaveButton label="Save" redirect="show" submitOnEnter={true} />
    {!props.saving && <ListButton label="Cancel" />}
  </Toolbar>
);
const SanitizedGrid = ({ basePath, ...props }) => {
  return <Grid {...props} />;
};

const AddonandVideoTaskLabelCreate = (props) => {

  return (
    <Create title={<PageTitle />} {...props} undoable={false}>
      <SimpleForm toolbar={<FormToolbar />} reValidateMode="onBlur" warnWhenUnsavedChanges redirect="list" >
        <SanitizedGrid container spacing={3} fullWidth>
          <Grid item sm={12} md={12} lg={12}>
            <TextInput label="Label 1" source="label1" fullWidth />
          </Grid>
          <hr></hr>
          <Grid item sm={12} md={12} lg={12}>
            <TextInput label="Label 2" source="label2" fullWidth />
          </Grid>
          <Grid item sm={12} md={6} lg={6}>
            <TextInput label="Option 1" source="option2a" fullWidth />
          </Grid>
          <Grid item sm={12} md={6} lg={6}>
            <TextInput label="Option 2" source="option2b" fullWidth />
          </Grid>
          <hr></hr>
          <Grid item sm={12} md={12} lg={12}>
            <TextInput label="Label 3" source="label3" fullWidth />
          </Grid>
          <Grid item sm={12} md={6} lg={6}>
            <TextInput label="Option 1" source="option3a" fullWidth />
          </Grid>
          <Grid item sm={12} md={6} lg={6}>
            <TextInput label="Option 2" source="option3b" fullWidth />
          </Grid>
          <hr></hr>
          <Grid item sm={12} md={12} lg={12}>
            <TextInput label="Label 4" source="label4" fullWidth />
          </Grid>
          <Grid item sm={12} md={6} lg={6}>
            <TextInput label="Option 1" source="option4a" fullWidth />
          </Grid>
          <Grid item sm={12} md={6} lg={6}>
            <TextInput label="Option 2" source="option4b" fullWidth />
          </Grid>
          <hr></hr>
          <Grid item sm={12} md={12} lg={12}>
            <TextInput label="Label 5" source="label5" fullWidth />
          </Grid>
          <Grid item sm={12} md={6} lg={6}>
            <TextInput label="Option 1" source="option5a" fullWidth />
          </Grid>
          <Grid item sm={12} md={6} lg={6}>
            <TextInput label="Option 2" source="option5b" fullWidth />
          </Grid>
          <Grid item sm={12} md={6} lg={6}>
            <TextInput label="Option 3" source="option5c" fullWidth />
          </Grid>
          <hr></hr>
          <Grid item sm={12} md={12} lg={12}>
            <TextInput label="Label 6" source="label6" fullWidth />
          </Grid>
          <Grid item sm={12} md={6} lg={6}>
            <TextInput label="Option 1" source="option6a" fullWidth />
          </Grid>
          <Grid item sm={12} md={6} lg={6}>
            <TextInput label="Option 2" source="option6b" fullWidth />
          </Grid>
          <Grid item sm={12} md={6} lg={6}>
            <TextInput label="Option 3" source="option6c" fullWidth />
          </Grid>
          <hr></hr>
          <Grid item sm={12} md={12} lg={12}>
            <TextInput label="Label 7" source="label7" fullWidth />
          </Grid>
          <Grid item sm={12} md={6} lg={6}>
            <TextInput label="Option 1" source="option7a" fullWidth />
          </Grid>
          <Grid item sm={12} md={6} lg={6}>
            <TextInput label="Option 2" source="option7b" fullWidth />
          </Grid>
          <Grid item sm={12} md={6} lg={6}>
            <TextInput label="Option 3" source="option7c" fullWidth />
          </Grid>
          <Grid item sm={12} md={6} lg={6}>
            <TextInput label="Current Post Id" source="post_id" fullWidth />
          </Grid>


        </SanitizedGrid>

      </SimpleForm>
    </Create>
  );
};
export default AddonandVideoTaskLabelCreate;
